import PropTypes from 'prop-types';
import React, { Component } from 'react';
import cx from 'classnames';
import { Dialog } from 'react-toolbox';
import { ThemeProvider } from 'react-css-themr';
import ReactSelect from 'components/StyledSelect/react_select';
import MessageBox from 'components/MessageBox';
import Loading from 'components/Loading';
import { MAX_EXCEL_FILE_SIZE } from 'config/constants';
import styles from 'styles/form';

const dialogTheme = { RTDialog: { dialog: styles.dialogOverflowVisible } };

const mediumInput = cx(styles.inputs, styles.mediumInput);

class UploadDialog extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.actions = [
      { label: 'Cancel', onClick: this.props.handleToggle },
      { label: 'Upload', onClick: this.handleSubmit },
    ];
  }

  handleSubmit = () => {
    const formData = new FormData();
    if (this.fileInput.files.length === 0) {
      this.props.setErrorMessage({ asset: ['Please select a file.'] });
      return;
    }
    if (this.fileInput.files[0].size > MAX_EXCEL_FILE_SIZE) { // 3MB
      this.props.setErrorMessage({ asset: ['Please select a file smaller than 3MB.'] });
      return;
    }
    formData.append(this.props.formDataKey, this.fileInput.files[0]);
    this.props.handleSubmit(formData);
  }

  renderErrors = () => {
    const uploadError = Object.keys(this.props.errors || {})
      .map(key => this.props.errors[key])
      .reduce((a, b) => a.concat(b), [])
      .join(', ');
    if (uploadError) return (<MessageBox error message={uploadError} />);
    return null;
  }

  renderCrewSelect = (crews, crewPayId) => {
    const options = crews.map(c => ({ value: c.id, label: c.name }));
    options.unshift({ value: 'i', label: 'Installer' });
    return (<ReactSelect
      className={mediumInput}
      label="Belongs To"
      placeholder={'Select Installer or Crew'}
      onChange={this.props.handleCrewPayId}
      options={options}
      value={crewPayId}
      required
    />);
  }

  render = () => {
    const { crews, crewPayId } = this.props;
    const errors = this.renderErrors();
    const loadingStatus = this.props.fileLoading ? (<Loading />) : null;
    return (<ThemeProvider theme={dialogTheme}>
      <Dialog
        actions={this.actions}
        active={this.props.active}
        title={this.props.title}
      >
        <div>
          {crews && this.renderCrewSelect(crews, crewPayId)}
          {errors}
          {loadingStatus}
          <input type="file" placeholder="Select a file" ref={(c) => { this.fileInput = c; }} />
        </div>
      </Dialog>
    </ThemeProvider>);
  }
}

UploadDialog.defaultProps = { crewPayId: null, crews: null, handleCrewPayId: () => {} };

UploadDialog.propTypes = {
  active: PropTypes.bool,
  title: PropTypes.string,
  errors: PropTypes.object,
  handleSubmit: PropTypes.func,
  handleToggle: PropTypes.func,
  fileLoading: PropTypes.bool,
  setErrorMessage: PropTypes.func.isRequired,
  formDataKey: PropTypes.string,
  crews: PropTypes.array,
  handleCrewPayId: PropTypes.func,
  crewPayId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default UploadDialog;



// WEBPACK FOOTER //
// ./client/app/shared/components/UploadDialog/index.jsx